import { useState } from 'react';
import { useHttpCalls } from '../../../../../api/useHttpCalls';
import { useEagGridConfig } from '../../../../../context/useEagGridConfig';
import { useEagGridStore } from '../../../../../store/useEagGridStore';
import { ExportOptions } from '../types/ExportOptions';
import { ExportState } from '../types/ExportState';
type UseExportProps = {
  onClose: () => void;
};
export function useExport(props: UseExportProps) {
  const http = useHttpCalls();
  const store = useEagGridStore();
  const {
    handleExportSuccessfullyStarted
  } = useEagGridConfig();
  const [exportState, setExportState] = useState<ExportState>('idle');
  const onExport = async (options: ExportOptions) => {
    const {
      queryId,
      columnStates,
      gridCode
    } = store.getState();
    if (!queryId) {
      return;
    }
    const columns = columnStates.filter(col => col.hidden !== true).toSorted((a, b) => a.order - b.order).map(col_0 => col_0.key);
    setExportState('exporting');
    try {
      const response = await http.postExport({
        dataQueryId: queryId,
        columns,
        ...options
      });
      if (response) {
        handleExportSuccessfullyStarted?.({
          exportId: response.exportId,
          gridCode
        });
        props.onClose();
      }
    } finally {
      setExportState('idle');
    }
  };
  return {
    exportState,
    onExport
  };
}